import { ListOnCallSpecialist } from '~/domain/usecases/onCallSpecialist/remote';
import {
  NotFound,
  BadRequestError,
  Forbidden,
  UnexpectedError,
  BadGateway,
} from '~/domain/errors';
import { HttpClient, HttpStatusCode } from '~/data/protocols/http';
import '~/infra/global/variables';

export class RemoteListOnCallSpecialist implements ListOnCallSpecialist {
  private readonly url: string;

  private readonly httpClient: HttpClient<ListOnCallSpecialist.Model>;

  constructor(url: string, httClient: HttpClient<ListOnCallSpecialist.Model>) {
    this.url = url;
    this.httpClient = httClient;
  }

  list = async (
    params: ListOnCallSpecialist.Params,
  ): Promise<ListOnCallSpecialist.Model> => {
    const httpResponse = await this.httpClient.request({
      url: this.url.replace('{onCallId}', params.onCallId.toString()),
      body: params.body,
      method: 'post',
    });
    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
      case HttpStatusCode.created:
      case HttpStatusCode.accepted:
      case HttpStatusCode.noContent:
        return httpResponse.body;
      case HttpStatusCode.badRequest:
        throw new BadRequestError();
      case HttpStatusCode.notFound:
        throw new NotFound();
      case HttpStatusCode.unauthorized:
        throw new Forbidden();
      case HttpStatusCode.badGateway:
        throw new BadGateway();
      default:
        throw new UnexpectedError();
    }
  };
}
